import React from 'react';
import useAuth from '../../../../../hooks/authentication/useAuth';
import { ForgotPasswordLandingForm } from '../../../../forgot-password/ForgotPasswordLandingForm';
import { AuthenticationsLayout } from '../../../../layouts/Authentications/AuthenticationsLayout';

export const ForgotPasswordLanding: React.FC = () => {
    const auth = useAuth();

    if (auth.isLoggedIn) {
        auth.forceLogout();
    }

    return (
        <>
            <AuthenticationsLayout>
                <ForgotPasswordLandingForm />
            </AuthenticationsLayout>
        </>
    );
};
